import { PublicClientApplication } from "@azure/msal-browser";

const rootUrl = window.location.origin;

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_ENTRA_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/' + import.meta.env.VITE_ENTRA_TENANT_ID,
    redirectUri: rootUrl, //'http://localhost:8081/',
    postLogoutUri: rootUrl //'http://localhost:8081/'
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false
  }
};

export const msalObj = new PublicClientApplication(msalConfig);
